"use client";

import { useCallback } from "react";

import { MapLevelBoundaryPanelContent } from "@/app/(internal)/panel/data/custom-layers/preview/_components/map-level-boundary-panel-content";
import { BoundaryPanelSkeleton } from "@/components/maps/map-panel/map-panel-details-panel/components/boundary-panel-plotting-section";
import { useAppSelector } from "@/providers/store/hooks";

import { useMapLevelBoundaryPanel } from "../_contexts/map-level-boundary-panel-context";
import { useWorkMapMapLevelBoundaryPanelPayload } from "../_hooks/use-work-map-map-level-boundary-panel-payload";

/** Working-map BOUNDARY panel body for MapLevel edit (Name + Note). */
export function WorkMapMapLevelBoundaryPanel() {
  const districtId = useAppSelector((state) => state.district.selectedDistrict?.id ?? null);
  const { updateBoundaryMetadata } = useMapLevelBoundaryPanel();
  const { boundaryPayload, isLoadingBoundaryDetails } =
    useWorkMapMapLevelBoundaryPanelPayload({ districtId });

  const handleSaveName = useCallback(
    (name: string) => {
      if (boundaryPayload == null) {
        return;
      }
      updateBoundaryMetadata(boundaryPayload.boundaryId, { name });
    },
    [boundaryPayload, updateBoundaryMetadata],
  );

  const handleSaveNote = useCallback(
    (note: string) => {
      if (boundaryPayload == null) {
        return;
      }
      updateBoundaryMetadata(boundaryPayload.boundaryId, { note });
    },
    [boundaryPayload, updateBoundaryMetadata],
  );

  if (isLoadingBoundaryDetails && boundaryPayload == null) {
    return <BoundaryPanelSkeleton />;
  }

  if (boundaryPayload == null) {
    return null;
  }

  return (
    <MapLevelBoundaryPanelContent
      isSaving={false}
      payload={boundaryPayload}
      onSaveName={handleSaveName}
      onSaveNote={handleSaveNote}
    />
  );
}
